module.exports = __webpack_public_path__ + "img/20200804_120317.5cc4491f.jpg";